import * as React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'common/appState';
import { Contract } from 'features/contract/models/contractModels';
import {
    getContracts,
    getFilteringContractsStatus,
} from 'features/contract/selectors/contractSelectors';
import { redirectToUrl } from 'common/actions/navigationAction';
import {
    saveFilters,
    autocompleteRequest,
    clearFilters,
    paginationRequest,
} from 'features/pagination/actions/paginationActions';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { RouteParams, getPageNumber } from 'common/selectors/routeSelectors';
import {
    archiveContractRequest,
    toggleMultipleEmployeesContractRoleRequest,
    unarchiveContractRequest,
} from 'features/contract/actions/contractActions';

import { EditContract as EditContractComponent } from '../components/EditContract';
import { isAdmin, isTenant } from 'features/user/selectors/userSelectors';

export interface EditContractStateProps {
    contracts: Contract[];
    isFiltered: boolean;
    isUserAdmin: boolean;
    isTenant: boolean;
    filter?: PaginationFilters;
    pageNumber?: number;
}

interface EditContractDispatchProps {
    redirectToUrl: typeof redirectToUrl;
    autocompleteRequest: typeof autocompleteRequest;
    clearFilters: typeof clearFilters;
    saveFilters: typeof saveFilters;
    paginationRequest: typeof paginationRequest;
    toggleMultipleEmployeesContractRoleRequest: typeof toggleMultipleEmployeesContractRoleRequest;
    archiveContractRequest: typeof archiveContractRequest;
    unarchiveContractRequest: typeof unarchiveContractRequest;
}

export type EditContractProps = EditContractDispatchProps & EditContractStateProps & RouteParams;

export class EditContract extends React.Component<EditContractProps> {
    public archiveContract = (contractId: number) => {
        this.props.archiveContractRequest(contractId);
    };
    public unarchiveContract = (contractId: number) => {
        this.props.unarchiveContractRequest(contractId);
    };

    public render(): JSX.Element {
        return (
            <EditContractComponent
                archiveContract={this.archiveContract}
                unarchiveContract={this.unarchiveContract}
                {...this.props}
            />
        );
    }
}
const mapStateToProps = (state: AppState, ownProps: RouteParams): EditContractStateProps => ({
    contracts: getContracts(state),
    isFiltered: getFilteringContractsStatus(state),
    isUserAdmin: isAdmin(state),
    isTenant: isTenant(state),
    filter: getFilterParams(state, PaginationView.Contracts),
    pageNumber: getPageNumber(ownProps),
});

export const EditContractContainer = connect(mapStateToProps, {
    redirectToUrl,
    autocompleteRequest,
    clearFilters,
    saveFilters,
    paginationRequest,
    toggleMultipleEmployeesContractRoleRequest,
    archiveContractRequest,
    unarchiveContractRequest,
})(EditContract);
